import React from "react";
import { UFOSegment } from "../analytics/react-ufo";
import { PerformanceSLOKey } from "./config";

/**
 * Use this component to monitor the performance of its children via an auto-generated service-level objective.
 * @param children
 * @param key The React UFO experience key for which to maintain an SLO.
 */
export const PerformanceSLO = ({
  children,
  ufo,
}: {
  children: React.ReactNode;
  ufo: PerformanceSLOKey;
}): React.JSX.Element => {
  return <UFOSegment name={ufo}>{children}</UFOSegment>;
};
